import { Score, ScoreIcon, ScoreIconStyle } from 'fable/ScoreIcon';

import { SatisfactionRatingReceivedMessage } from '../components/SatisfactionRatingReceivedMessage';

type CsatRatingMessageProps = {
  comment: string;
  score: Score;
  ratingStyle: ScoreIconStyle;
};

export const CsatRatingMessage = ({
  ratingStyle,
  score,
  comment,
}: CsatRatingMessageProps): JSX.Element => (
  <SatisfactionRatingReceivedMessage
    scoreElement={<ScoreIcon style={ratingStyle} score={score} />}
    tooltipContent={`${score} out of 5`}
    ratingTypeLabel="CSAT"
    comment={comment}
  />
);
